import { scrollTo } from '../../../utils/scroll';

export const resetScrollOnRefresh = () => {
    const isOnIOS = navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i);
    const eventName = isOnIOS ? 'unload' : 'beforeunload';
    window[`on${eventName}`] = () => {
        scrollTo(0, { duration: 0 });
        window.scrollTo(0, 0);
    };
};
